import {
  CollectionFilter,
  CollectionItemType,
  ProfileCollectionItem,
} from '@app/profile/profile-api.model';

export const getItemIndex = (
  item: ProfileCollectionItem<any>,
  allItems: ProfileCollectionItem<any>[]
): number => {
  return getFirstItemIndex(item, allItems, (item1, item2) => {
    return (
      item1.userItemId === item2.userItemId &&
      item1.contentType === item2.contentType
    );
  });
};

export const getFirstItemIndex = (
  item: ProfileCollectionItem<any>,
  collection: ProfileCollectionItem<any>[],
  comparer: (
    item1: ProfileCollectionItem<any>,
    item2: ProfileCollectionItem<any>
  ) => boolean
): number => {
  let idx = -1;
  let i = 0;
  for (; i < collection.length; i++) {
    if (comparer(item, collection[i])) {
      idx = i;
      break;
    }
  }
  return idx;
};

export const getTotalCount = (values: CollectionItemType[]): number => {
  let total = 0;
  values.forEach((value) => {
    total += value.count;
  });
  return total;
};

// TODO check if this is still needed
export const normalizeItems = (arr) => {
  arr.forEach((item) => {
    item.userItemId = parseInt(item.userItemId);
  });
  return arr;
};

const TILE_TYPES = {
  Event: 'input',
  Course: 'input',
  Book: 'input',
  Article: 'input',
  Video: 'input',
  Assessment: 'input',
  Position: 'experience',
  Episode: 'input',
  Task: 'input',
  Degree: 'outcome',
  Skill: 'outcome',
  Accomplishment: 'outcome',
  Badge: 'outcome',
  Award: 'outcome',
  Certificate: 'outcome',
};

export const isOutcomeTile = (type: string): boolean => {
  return TILE_TYPES[type] === 'outcome';
};

export const isExperienceTile = (type: string): boolean => {
  return TILE_TYPES[type] === 'experience';
};

interface CollectionQueryParams {
  provider?: string | string[];
  type?: string | string[];
  tags?: string | string[];
  term?: string;
  startDate?: string;
  endDate?: string;
  classifier?: string;
  pathwayStatus?: string | string[];
  targetStatus?: string | string[];
  experienceType?: string | string[];
}

export const initFilter = (params: CollectionQueryParams): CollectionFilter => {
  const {
    type,
    tags,
    provider,
    term,
    startDate,
    endDate,
    classifier = 'learning',
    pathwayStatus,
    targetStatus,
    experienceType,
  } = params;

  const parseQueryParamForStringArray = (param): string[] => {
    if (!param) {
      return [];
    }
    return Array.isArray(param) ? param : [param];
  };

  return {
    type: parseQueryParamForStringArray(type),
    tags: parseQueryParamForStringArray(tags),
    providers: parseQueryParamForStringArray(provider),
    term: term || '',
    startDate: startDate ? new Date(startDate) : null,
    endDate: endDate ? new Date(endDate) : null,
    currentItemClassifier: classifier,
    pathwayStatus: parseQueryParamForStringArray(pathwayStatus),
    targetStatus: parseQueryParamForStringArray(targetStatus),
    experienceType: parseQueryParamForStringArray(experienceType),
  };
};
